import React from 'react';
import request from 'helpers/request';

const AppContext = React.createContext();

const arrayToObject = (array, key) =>
  array.reduce((obj, item) => {
    obj[item[key]] = item;
    return obj;
  }, {});
const getActiveAccountId = () => {
  const activeAcctId = localStorage.getItem('active-account');
  if (activeAcctId) {
    return Number(activeAcctId);
  }
  return null;
};
const getStatusPageUrl = freshid_accounts_name => {
  const { hostname } = window.location;
  return hostname.indexOf('localhost') > -1 || hostname.indexOf('sta91ng') > -1
    ? `https://${freshid_accounts_name}.freshstatus-sta91ng.io`
    : `https://${freshid_accounts_name}.freshstatus.io`;
};
class AppProvider extends React.Component {
  state = {
    isAuth: false,
    user: null,
    components: null,
    componentState: 'idle',
    currentPage: null,
    accounts: null,
    accountsMeta: null,
    currentAccount: null,
    currentAccountMeta: null,
    statusPageUrl: '',
    freshIdSessionState: null,
    freshIdSessionToken: null,
    activationState: null,
    featureInterest: {
      open: false,
      type: ''
    },
    integrations: {
      open: false,
      type: ''
    },
    entities: {
      components: {},
      incidents: {}
    },
    incidents: {
      state: 'idle' // | 'idle' | 'success' | 'failed'
    }
  };

  activeAccountRef = React.createRef();

  componentDidMount() {
    if (window.location.pathname.indexOf('/admin') > -1) {
      if (window.localStorage.getItem('auth-token')) {
        this.activeAccountRef.current = getActiveAccountId();
        this.setState({ isAuth: true });
        this.getCurrentUser();
        this.getCurrentUserAccounts();
        this.getCurrentUserAccountsMeta();
        this.setFreshIdSession();
        this.getComponents();
      }
    }
    window.freshworksOmnibar = {
      onSessionStateChanged: function callback() {
        console.log('#### freshid got disconnected ####');
        localStorage.clear();
        window.location.href = '/admin';
      }
    };
  }

  getCurrentUser = async () => {
    this.activeAccountRef.current = getActiveAccountId();
    const user = await request('/logged-in-user/');
    if (!(user.results && user.results.length)) return;

    this.setState({ user: user.results[0] });
    this.getUserActivationState(user.results[0]);
    const currentUser = { ...user.results[0] };

    if (window.fcWidget) {
      window.fcWidget.setExternalId(currentUser.id);
      window.fcWidget.user.setEmail(currentUser.email);
    }
    // if (window.Autopilot) {
    //   window.Autopilot.run('associate', {
    //     Email: currentUser.email,
    //     Project: 'Freshstatus',
    //     Name: currentUser.full_name,
    //     custom: { ...currentUser }
    //   });
    // }

    // if (window.Appcues) {
    //   window.Appcues.identify(currentUser.id, {
    //     firstName: currentUser.full_name,
    //     email: currentUser.email
    //   });
    // }

    if (window.beamer_config) {
      window.beamer_config.user_firstname = currentUser.full_name;
      window.beamer_config.user_lastname = '';
      window.beamer_config.user_email = currentUser.email;
      window.beamer_config.user_id = currentUser.id;
      if (window.Beamer) window.Beamer.init();
    }
  };

  getCurrentUserAccounts = async () => {
    const accounts = await request('/accounts/', {}, true);
    const currentAccount = accounts.results.find(
      r => r.id === this.activeAccountRef.current
    );
    this.setState({
      accounts: accounts.results,
      currentAccount,
      statusPageUrl: getStatusPageUrl(currentAccount.freshid_accounts_name)
    });
  };

  getCurrentUserAccountsMeta = async () => {
    const accountsMeta = await request('/accounts-meta/');
    const currentAccountMeta =
      accountsMeta &&
      accountsMeta.results &&
      accountsMeta.results.find(
        r => r.account_id === this.activeAccountRef.current
      );
    this.setState({
      accountsMeta: accountsMeta.results,
      currentAccountMeta
    });
  };

  setFreshIdSession = async () => {
    const freshIdSessionState = window.localStorage.getItem('freshid-session-state');
    const freshIdSessionToken = window.localStorage.getItem('freshid-session-token');
    this.setState({
      freshIdSessionState: freshIdSessionState,
      freshIdSessionToken: freshIdSessionToken
    });
  };

  getUserActivationState = async account => {
    const accountMember = await request(
      `/account-members/?user_id=${account.id}`
    );
    if (accountMember.results) {
      this.setState({
        activationState:
          accountMember && accountMember.results[0].user_verification_state
      });
    }
  };

  updateCurrentPage = currentPage => {
    this.setState({ currentPage });
  };

  getIncidentStatus = async id => {
    const incident = await request(`/incident-statuses/${id}/`);
    this.setState({
      entities: {
        ...this.state.entities,
        incidents: {
          ...this.state.entities.incidents,
          [incident.incident]: {
            ...this.state.entities.incidents[incident.incident],
            status: incident.status
          }
        }
      }
    });
    return incident;
  };

  getIncident = async id => {
    const incident = await request(`/incidents/${id}`);
    this.setState({
      entities: {
        ...this.state.entities,
        incidents: {
          ...this.state.entities.incidents,
          [incident.id]: {
            ...this.state.entities.incidents[incident.id],
            ...incident
          }
        }
      }
    });
    return incident;
  };

  getIncidentFromStore = id => {
    const { incidents } = this.state.entities;
    return incidents[id];
  };

  updateIncidentInStore = incident => {
    this.setState({
      entities: {
        ...this.state.entities,
        incidents: {
          ...this.state.entities.incidents,
          [incident.id]: {
            ...this.state.entities.incidents[incident.id],
            ...incident
          }
        }
      }
    });
  };

  getComponents = async () => {
    this.setState({
      componentState: 'loading'
    });
    const components = await request('/component-statuses/');
    this.setState({
      components: components.results,
      componentState: 'success',
      entities: {
        ...this.state.entities,
        components: arrayToObject(components.results, 'component')
      }
    });
  };

  addIntegration = type => {
    this.setState({
      integrations: {
        open: true,
        type
      }
    });
  };

  closeIntegrations = () => {
    this.setState({ integrations: { open: false, type: '' } });
  };

  render() {
    return (
      <AppContext.Provider
        value={{
          user: this.state.user,
          accounts: this.state.accounts,
          accountsMeta: this.state.accountsMeta,
          currentAccount: this.state.currentAccount,
          currentAccountMeta: this.state.currentAccountMeta,
          isAuth: this.state.isAuth,
          incidents: this.state.incidents,
          integrations: this.state.integrations,
          currentPage: this.state.currentPage,
          components: this.state.components,
          componentState: this.state.componentState,
          activationState: this.state.activationState,
          connectionType: this.state.connectionType,
          statusPageUrl: this.state.statusPageUrl,
          freshIdSessionState: this.state.freshIdSessionState,
          freshIdSessionToken: this.state.freshIdSessionToken,
          getCurrentUser: this.getCurrentUser,
          getCurrentUserAccounts: this.getCurrentUserAccounts,
          getCurrentUserAccountsMeta: this.getCurrentUserAccountsMeta,
          setFreshIdSession: this.setFreshIdSession,
          getComponents: this.getComponents,
          addIntegration: this.addIntegration,
          closeIntegrations: this.closeIntegrations,
          updateCurrentPage: this.updateCurrentPage,
          getIncidentStatus: this.getIncidentStatus,
          getIncident: this.getIncident,
          updateIncidentInStore: this.updateIncidentInStore,
          getIncidentFromStore: this.getIncidentFromStore,
          getUserActivationState: this.getUserActivationState
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

const AppConsumer = AppContext.Consumer;

export { AppProvider, AppConsumer };
